import SessionInfo from './SessionInfo'
export default SessionInfo
